export default __webpack_public_path__ + "static/media/retry.0ebab968.svg";